<div class="mb-3">
    <div
        *ngIf="secondClassPrice >= trainFreePrice"
        class="alert mt-3 mb-3">
        <p>
            <i class="icon icon--inline euro--medium"></i>
            {{ 'COMPOSE.ROUTE.PRICE_ALERT' | translate: { price: (trainFreePrice | priceFormat) } }}
        </p>
    </div>
    <hr class="articleSeparator priceSummaryLine">
    <h2 class="headingS">
        {{ 'COMPOSE.ROUTE_PRICE_MONTH' | translate}}
        <span class="float-right">€ {{ secondClassPrice | priceFormat }}</span>
    </h2>
</div>
